import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const getCourseLanguages = (courseId) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/creator_studio/courses`,
    queryParams: [
      {
        name: 'course_id',
        value: courseId,
      },
    ],
  });
};

export default getCourseLanguages;
